module.exports = __webpack_public_path__ + "img/chinesecompany104.0ae530dc.png";